import { CraBillingOptions } from './CRABillingOptions';
import { Address, AddressType } from './Address';

export class Cra {
    id: number;
    craName!: string;
    companyWebsite!: string;
    systemId!: string;
    contactName!: string;
    email!: string;
    phone: string;
    phone2: string;
    fax: string;
    fax2: string;
    craBillingOptions = new CraBillingOptions();
    createdDate: Date;
    craPhysicalAddress = new Address();
    craBillingAddress = new Address();
    craDisplayedToClientsAddress = new Address();
    craDisplayedOnReportsAndFormsAddress = new Address();
    craDisplayedOnInvoicesAddress = new Address();

    constructor() {
        this.craBillingOptions = new CraBillingOptions();
        this.craPhysicalAddress = new Address();
        this.craPhysicalAddress.addressType = AddressType.Physical;
    }

    // notes?: CraNote[];
    isActive: boolean;
}

export class CraNote {
    id: number;
    userId: number;
    craId: number;
    note: string;
    noteType: CraNoteType;
    createdDate: Date;
    prettyCreatedDate: string;
    creatingUserName: string;
}

export class CraNoteType {
    constructor(id: number, name: string, cls: string) {
        this.id = id;
        this.displayName = name;
        this.className = cls;
    }

    id: number;
    displayName: string;
    className: string;
}
